/**
 * List of supported Segment Creative Types
 * @param options object of options to build the list
 */
export function list(options = {}) {
  const vibenomicsList = [
    {
      label: 'Attached',
      value: false,
    },
    {
      label: 'Missing',
      value: true,
    },
  ];

  const nonVibenomicsList = [
    {
      label: 'N/A',
      value: 'N/A',
    },
  ];

  if (options === true) {
    return vibenomicsList;
  }

  return nonVibenomicsList;
}

export default {
  list,
};
